import { Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';

import { AttachedFilesPermissions } from '../../../../MonthlyServiceRequest/RequestDetailTypes';
import LineRowApprovalPending from '../LineRowApprovalPending/LineRowApprovalPending';
import './DailyWorkReportApproval.scss';
import { ubicationTypeEnum } from '../../../../../utils/dataStatus';

const DailyWorkReportApproval = (props) => {
  const {
    contractLevel,
    providerOrUbication,
    service,
    fetchData,
    selectedDate,
    selectedInput,
    showApproveButton,
    showEditButton,
    showRejectButton,
    permissions,
    showPPButton
  } = props;

  return (
    <div className="work-report-body-container">
      {contractLevel.map(({ agrupadoPor: contract, items: partesTrabajoDiario }) => (
        <>
          <h5>
            <div className="sub-header-container">
              {' '}
              {providerOrUbication} - {contract} - {service}
            </div>
          </h5>
          <Row className="header-line-table-approval">
            <Col className="gy-0" sm={3}>
              Posición
            </Col>
            <Col sm={3}>Línea</Col>
            <Col sm={1}>UM</Col>
            <Col sm={2}>Cantidad</Col>
            <Col sm={1}> </Col>
            {showPPButton &&
              partesTrabajoDiario[0].tipoUbicacionEnum === ubicationTypeEnum.pozo && (
                <>
                  <Col sm={1} style={{ textAlign: 'left', padding: '3px' }}>
                    <span style={{ padding: '0px' }}>P.Prog</span>
                    <span style={{ marginLeft: '10px' }}>Cod.</span>
                  </Col>
                </>
              )}
          </Row>
          {partesTrabajoDiario?.map((dailyWorkReport) => (
            <LineRowApprovalPending
              cantidad={dailyWorkReport?.cantidad}
              dailyWorkReport={dailyWorkReport}
              fetchData={fetchData}
              key={dailyWorkReport?.idParteDiario}
              lineaSap={dailyWorkReport?.lineaSap}
              permissions={permissions}
              posicionSap={dailyWorkReport?.posicionSap}
              selectedDate={selectedDate}
              selectedInput={selectedInput}
              showApproveButton={showApproveButton}
              showEditButton={showEditButton}
              showPPButton={showPPButton}
              showRejectButton={showRejectButton}
              unidadMedida={dailyWorkReport?.unidadMedida}
            />
          ))}
        </>
      ))}
    </div>
  );
};

export default DailyWorkReportApproval;

DailyWorkReportApproval.propTypes = {
  contractLevel: PropTypes.arrayOf().isRequired,
  providerOrUbication: PropTypes.string.isRequired,
  service: PropTypes.string.isRequired,
  fetchData: PropTypes.func.isRequired,
  selectedDate: PropTypes.string.isRequired,
  selectedInput: PropTypes.string.isRequired,
  showApproveButton: PropTypes.bool.isRequired,
  showEditButton: PropTypes.bool.isRequired,
  showRejectButton: PropTypes.bool.isRequired,
  permissions: AttachedFilesPermissions,
  showPPButton: PropTypes.bool.isRequired
};

DailyWorkReportApproval.defaultProps = {
  permissions: {
    visualize: false,
    write: false
  }
};
